import React from 'react';

const Menu2 = (props) => (
  React.createElement('svg', {
    xmlns: 'http://www.w3.org/2000/svg',
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    stroke: 'currentColor',
    fill: 'none',
    strokeWidth: '2',
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    ...props,
  }, /* #__PURE__ */React.createElement('line', {
    x1: '3',
    y1: '12',
    x2: '17',
    y2: '12',
  }), /* #__PURE__ */React.createElement('line', {
    x1: '3',
    y1: '6',
    x2: '21',
    y2: '6',
  }), /* #__PURE__ */React.createElement('line', {
    x1: '3',
    y1: '18',
    x2: '21',
    y2: '18',
  }))
);

Menu2.propTypes = {};

Menu2.displayName = 'Menu2';

export default Menu2;
